/* eslint-disable */
export default {
  mute: 'Stummschalten',
  unmute: 'Stummschaltung aufheben',
  hangup: 'Auflegen',
  reject: 'Ablehnen',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
